<template>
<div class="chapter">
<div class="inner_page">
<p class="halftitleb"><a id="sub"></a><a id="page_xv"></a><strong><span class="smallcaps">SCIENTISTS AND SWINDLERS</span></strong><a id="page_xvi"></a></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch00_fm09_sub.vue?07b87f96